<template>
  <ModuleContainer v-bind="bindModule">
    <template #draggable="props">
      <DraggablePopup
        v-bind="props"
        id="legend-panel"
        :show="true"
        title="Chú giải"
        :top="80"
        :left="10"
        :width="250"
        :height="panelHeight"
        disable-close
        :is-resizable="false"
      >
        <div ref="content" class="legend-content px-3 pb-3 pt-2">
          <div v-if="!legends || legends.length === 0" class="text-center grey--text py-2" style="font-size: 12px; font-style: italic;">
            Chưa có chú giải
          </div>
          <div v-for="item in legends" :key="item.id" class="legend-item mt-2">
            
            <!-- List Type -->
            <div v-if="item.type === 'list'" class="d-flex align-center">
              <div class="color-box" :style="{ backgroundColor: item.color }"></div>
              <span class="ml-2 text-body-2">{{ item.title }}</span>
            </div>
            
            <!-- Image Type -->
            <div v-else-if="item.type === 'image'" class="mt-1">
              <img :src="getImageUrl(item.image_path)" class="legend-image" @load="calcHeight" />
            </div>

          </div>
        </div>
      </DraggablePopup>
    </template>
  </ModuleContainer>
</template>

<script>
import { DraggablePopup } from '@components/draggable'
import ModuleMixin from '@components/Map/mixins/ModuleMixin'
import ModuleContainer from '@components/Map/ModuleContainer.vue'

export default {
  name: 'LegendPanel',
  components: { DraggablePopup, ModuleContainer },
  mixins: [ModuleMixin],
  props: {
    position: {
      type: String,
      default: 'top-left'
    },
    legends: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    contentHeight: 60
  }),
  computed: {
    panelHeight() {
      return Math.max(this.contentHeight + 58, 100)
    }
  },
  watch: {
    legends: {
      handler() {
        this.calcHeight()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.calcHeight()
  },
  updated() {
    this.calcHeight()
  },
  methods: {
    calcHeight() {
      this.$nextTick(() => {
        if (this.$refs.content) {
          const h = this.$refs.content.scrollHeight
          if (h > 0 && h !== this.contentHeight) {
            this.contentHeight = h
          }
        }
      })
    },
    getImageUrl(path) {
      if (!path) return ''
      if (path.startsWith('http')) return path
      let baseUrl = process.env.VUE_APP_API_URL || ''
      if (baseUrl.endsWith('/api/') || baseUrl.endsWith('/api')) {
        baseUrl = baseUrl.replace(/\/api\/?$/, '')
      }
      return baseUrl ? `${baseUrl}${path}` : path
    }
  }
}
</script>

<style scoped>
.color-box {
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  flex-shrink: 0;
}
.legend-item {
  word-break: break-word;
}
.legend-image {
  max-width: 100%;
  height: auto;
  display: block;
  border-radius: 4px;
}

::v-deep .overflow-auto {
  overflow: hidden !important;
}
</style>
